import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export const AdyenFeaturesCard = () => {
    const { t } = useTranslation('processors')
    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('adyen.features.title')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('adyen.features.paymentProcessing')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('adyen.features.globalPaymentProcessing')}</li>
                            <li>{t('adyen.features.multiCurrency')}</li>
                            <li>{t('adyen.features.threeDSecure')}</li>
                            <li>{t('adyen.features.recurringPayments')}</li>
                            <li>{t('adyen.features.realtimeMonitoring')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('adyen.features.paymentMethods')}</h4>
                        <ul className="list-disc pl-4 text-sm text-muted-foreground space-y-1">
                            <li>{t('adyen.features.cardMethods')}</li>
                            <li>{t('adyen.features.walletMethods')}</li>
                            <li>{t('adyen.features.digitalWallets')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-sm font-medium text-muted-foreground mb-2">{t('adyen.features.supportedCountries')}</h4>
                        <div className="rounded-lg bg-muted p-4">
                            <p className="text-sm text-muted-foreground">
                                {t('adyen.features.countries')}
                            </p>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
